export const CodeSearchBar = ({ query, onChange }) => {
  return (
    <div className="pb-3">
      <div className="row p-1 m-0 search-bar bg-green">
        <div className="col-4 col-sm-2 col-xxl-1 px-2 align-content-center p-0">
          <h5 className="m-0"><i className="bi bi-search" /> Search</h5>
        </div>
        <div className="col col-sm col-xl p-0">
          <input
            className="form-control"
            id="code-input"
            type="text"
            maxLength="12"
            placeholder="XYZ123"
            value={query}
            onChange={(event) => onChange(event.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

